module.exports = __webpack_public_path__ + "console/img/中通.5be0c641.jpg";